import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {GatewayOrderCreateRequest} from "../model/gateway/gatewayOrderCreateRequest";
import {GatewayOrder} from "../model/gateway/gatewayOrder";
import {HubEnvironmentOption} from "../model/gateway/hubEnvironmentOption";

@Injectable({
  providedIn: 'root'
})
export class GatewayOrderService {

  private readonly API_PREFIX = environment.apiUrlGatewayOrderPrefix;

  private http = inject(HttpClient);

  public createGatewayOrder(request: GatewayOrderCreateRequest): Observable<GatewayOrder> {
    return this.http.post<GatewayOrder>(this.API_PREFIX.substring(0, this.API_PREFIX.length - 1), request);
  }

  public getAll(): Observable<GatewayOrder[]> {
    return this.http.get<GatewayOrder[]>(this.API_PREFIX.substring(0, this.API_PREFIX.length - 1));
  }

  public findHubEnvironments(): Observable<HubEnvironmentOption[]> {
    return this.http.get<HubEnvironmentOption[]>(this.API_PREFIX + 'hub-environments');
  }

  public findById(gatewayOrderId: number): Observable<GatewayOrder> {
    return this.http.get<GatewayOrder>(this.API_PREFIX + gatewayOrderId);
  }

  public updateOrderName(gatewayOrderId: number, orderName: string): Observable<GatewayOrder> {
    return this.http.patch<GatewayOrder>(this.API_PREFIX + gatewayOrderId, {orderName});
  }

  public findByImei(imei: string): Observable<GatewayOrder[]> {
    return this.http.get<GatewayOrder[]>(this.API_PREFIX + 'imei/' + imei);
  }

  public importDevices(gatewayOrderId: number, file: File): Observable<GatewayOrder> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<GatewayOrder>(this.API_PREFIX + gatewayOrderId + '/devices/import', formData);
  }

  public createOrRetryDevices(gatewayOrderId: number, gatewayOrderDeviceIds: number[]): Observable<GatewayOrder> {
    return this.http.patch<GatewayOrder>(
      this.API_PREFIX + gatewayOrderId + '/devices/retry',
      {gatewayOrderDeviceIds}
    );
  }

  public deleteDevices(gatewayOrderId: number, gatewayOrderDeviceIds: number[]): Observable<GatewayOrder> {
    return this.http.delete<GatewayOrder>(
      this.API_PREFIX + gatewayOrderId + '/devices',
      {body: {gatewayOrderDeviceIds}}
    );
  }

  public downloadSecureInReachConfigs(gatewayOrderId: number): Observable<ArrayBuffer> {
    return this.http.get(
      this.API_PREFIX + gatewayOrderId + '/devices/downloadSecureInReachConfigs',
      {responseType: 'arraybuffer'}
    );
  }
}
